<template>
  <div class="chat-wrapper">
    <div class="chat-header">
      <DxButton icon="trash" type="success" text="Limpar" @click="limpar()" />
      <DxButton icon="eyeopen" type="danger" text="Enviar chat para análise" />
    </div>

    <div class="messages" ref="messages">
      <div v-for="(msg, index) in messages" :key="index" :class="['message', msg.sender]">
        <!-- Mensagem do usuário -->
        <div v-if="msg.sender === 'user'">
          {{ msg.text }}
        </div>

        <!-- Mensagem do bot (tabela ou texto) -->
        <div v-else>
          <!-- Tabela -->
          <div class="table-container" v-if="Array.isArray(msg.text)">
            <table class="chat-table">
              <thead>
                <tr>
                  <th v-for="(value, key) in msg.text[0]" :key="key">{{ key }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in msg.text" :key="index">
                  <td v-for="(value, key) in item" :key="key">{{ value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Texto simples -->
          <div v-else>
            {{ msg.text }}
          </div>
        </div>
      </div>

      <!-- Loader -->
      <DxLoadIndicator
        :height="20"
        :width="20"
        :visible="status"
      />
    </div>

    <!-- Input fixo -->
    <div class="chat-input-container">
      <input type="text" v-model="userMessage" @keyup.enter="sendMessage" placeholder="Digite sua mensagem..." />
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import DxButton from 'devextreme-vue/button';

export default {
  data() {
    return {
      messages: [],
      userMessage: '',
      status: false,
      threadId: '',
      user: {}
    };
  },
  created(){
    //iniciar uma nova thread
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  methods: {
    async startThread(){
      var resultThread = await api.get(`chat/startThread/${this.user.cd_usuario}`)
      this.threadId = resultThread.threadId
    },
    async sendMessage() {
      if (!this.userMessage.trim()) return;
      this.messages.push({ text: this.userMessage, sender: 'user' });
      this.scrollToBottom();
      await this.getBotResponse(this.userMessage);
      this.userMessage = '';
    },
    limpar() {
      this.messages = [];
    },
    async getBotResponse(userInput) {
      this.status = true;

      const resp_bot = await api.post_padrao(`chat/${this.user.nm_empresa}/send_mensagem`, {
        mensagem: userInput,
        from: this.user.cd_usuario
      });

      if (resp_bot.tipo === 'sql') {
        const json = { script: resp_bot.resposta };
        const result = await api.post('exec_sql', json);
        this.messages.push({ text: result, sender: resp_bot.from });
      } else {
        this.messages.push({ text: resp_bot.resposta, sender: resp_bot.from });
      }

      this.status = false;
      this.scrollToBottom();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messages;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
  },
  components: {
    DxLoadIndicator,
    DxButton
  }
};
</script>
<style lang="scss">
.chat-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #f0f0f5;
  font-family: 'Segoe UI', sans-serif;
}

.chat-header {
  display: flex;
  gap: 10px;
  padding: 10px;
  background-color: #ffffff;
  border-bottom: 1px solid #ddd;
  justify-content: flex-start;
}

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 15px;
  line-height: 1.4;
  word-wrap: break-word;
}

.user {
  align-self: flex-end;
  background-color: #007bff;
  color: #fff;
}

.chatbot {
  align-self: flex-start;
  background-color: #e6e6eb;
  color: #000;
}

.chat-input-container {
  border-top: 1px solid #ccc;
  padding: 10px;
  background-color: #fff;
}

.chat-input-container input {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
}

.table-container {
  overflow-x: auto;
  max-width: 100%;
  padding-top: 10px;
}

.chat-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.chat-table th,
.chat-table td {
  padding: 8px 12px;
  border: 1px solid #ccc;
  text-align: left;
  font-size: 14px;
}

.chat-table th {
  background-color: #007bff;
  color: white;
  position: sticky;
  top: 0;
}
</style>